import { render, staticRenderFns } from "./MultipleTeamSelector.vue?vue&type=template&id=fe1988d8"
import script from "./MultipleTeamSelector.vue?vue&type=script&lang=js"
export * from "./MultipleTeamSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports